<template>
  <div class="page t-container">
    <span class="page-subheading t-text-xs t-text-gray-600 t-font-medium"
      >HOME | DEPOT
    </span>
    <div class="page-heading" role="heading">
      <div
        class="t-flex t-flex-col md:t-flex-row t-space-y-2 md:t-space-y-0 t-justify-end t-items-start md:t-items-center t-mt-3 md:t-mt-0"
      >
        <h1 class="page-heading__header" style="margin-right: 50px;">
          Depot
        </h1>
        <Multiselect
          v-bind="msDepot"
          :value="depot"
          :options="getDepots"
          @change="refreshDepotConsignmentTab"
          style="width: 280px;"
        />
      </div>
    </div>

    <div class="tabs-container">
      <nav class="tabs-menu t-space-x-4 md:t-space-x-6">
        <a @click.prevent="changeTab('DepotIncomingConsignmentsTab')">
          <span
            class="t-pb-2"
            :class="{
              't-border-b-2 t-border-dodger-blue':
                currentTab === 'DepotIncomingConsignmentsTab'
            }"
          >
            Incoming
          </span>
        </a>
        <a @click.prevent="changeTab('DepotOutgoingConsignmentsTab')">
          <span
            class="t-pb-2"
            :class="{
              't-border-b-2 t-border-dodger-blue':
                currentTab === 'DepotOutgoingConsignmentsTab'
            }"
          >
            Outgoing
          </span>
        </a>
        <a @click.prevent="changeTab('DepotBinLocationsTab')">
          <span
            class="t-pb-2"
            :class="{
              't-border-b-2 t-border-dodger-blue':
                currentTab === 'DepotBinLocationsTab'
            }"
          >
            Bin Locations
          </span>
        </a>
        <a
          v-if="isDepotSupremeCleaningProduct"
          @click.prevent="changeTab('FreightEventsTab')"
        >
          <span
            class="t-pb-2"
            :class="{
              't-border-b-2 t-border-dodger-blue':
                currentTab === 'FreightEventsTab'
            }"
          >
            Freight Events
          </span>
        </a>
      </nav>
    </div>

    <depot-consignments-tab :consignments-type="consignmentsType" ref="foo" />
  </div>
</template>

<script>
import DepotConsignmentsTab from "./DepotConsignmentsTab";
import Multiselect from "@vueform/multiselect/dist/multiselect.vue2.js";

export default {
  name: "DepotPage",
  components: {
    DepotConsignmentsTab,
    Multiselect
  },
  data() {
    return {
      currentTab: "DepotIncomingConsignmentsTab",
      consignmentsType: "INCOMING",
      msDepot: {
        placeholder: "Select a depot",
        searchable: true
      }
    };
  },
  created() {
    this.$store.dispatch("loadAllDepots");
  },
  methods: {
    changeTab(newTab) {
      this.currentTab = newTab;
      if (newTab === "DepotIncomingConsignmentsTab") {
        this.consignmentsType = "INCOMING";
      } else if (newTab === "DepotOutgoingConsignmentsTab") {
        this.consignmentsType = "OUTGOING";
      } else if (newTab === "DepotBinLocationsTab") {
        this.consignmentsType = "BIN LOCATION";
      } else {
        this.consignmentsType = "FREIGHT EVENT";
      }
    },
    refreshDepotConsignmentTab(val) {
      this.$refs.foo.fetchConsignments(1, val);
      this.$store.dispatch("assignSelectedDepot", val);
    }
  },
  computed: {
    getDepots() {
      return this.$store.getters.getDepots;
    },
    depot() {
      return this.$store.getters.getDepot;
    },
    isDepotSupremeCleaningProduct() {
      return this.getDepots.some(
        el => el.label === "Supreme Cleaning Products"
      );
    }
  }
};
</script>

<style src="@vueform/multiselect/themes/default.css"></style>

<style scoped></style>
